import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeFrame12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCodeFrame12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.5.5V3h10v-.5a.5.5 0 0 0-.5-.5m.5 2H1v5.786a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM1.5 1A1.5 1.5 0 0 0 0 2.5v7.286a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V2.5A1.5 1.5 0 0 0 10.5 1zm2.856 4.246a.5.5 0 0 1 0 .708L3.14 7.169l1.216 1.216a.5.5 0 0 1-.707.707l-1.57-1.57-.353-.353.354-.353 1.569-1.57a.5.5 0 0 1 .707 0m3.288 0a.5.5 0 0 0 0 .708L8.86 7.169 7.644 8.385a.5.5 0 0 0 .707.707l1.57-1.57.353-.353-.354-.353-1.57-1.57a.5.5 0 0 0-.706 0m-.549.622a.5.5 0 0 0-.933-.359L5.009 8.512a.5.5 0 0 0 .933.359z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeFrame12);
